import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { Divider, Grid, Paper, Button } from "@material-ui/core";
import Axios from "axios";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import moment from "moment";

import GetAppIcon from "@material-ui/icons/GetApp";
import BookIcon from "@material-ui/icons/Book";
import StoreIcon from "@material-ui/icons/Store";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import ShopIcon from "@material-ui/icons/Shop";

import { url } from "../../../../config/config";
import Header from "../../../../Component/NavBar/User/Header/Header";
import Footer from "../../../../Component/NavBar/User/Footer/Footer";
import Specification from "./Specification";
import Description from "./Description";
import SimilarGenreBooks from "./SimilarGenreBooks/SimilarGenreBooks";
import SimilarAuthorBooks from "./SimilarAuthorBooks/SimilarAuthorBooks";
import CustomLoader from "../../../../Component/CustomLoader/CustomLoader";
import { useStyles } from "./UserDetailBook.css";

class UserDetailBook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bookData: [],
      authorData: [],
      cartCount: 0,
      notificationOpen: false,
      bottomNavigation: [
        {
          label: "Specification",
        },
        {
          label: "Description",
        },
      ],
      soldBooks: [],
      currentPage: "Specification",
      success: "",
      alreadyExist: "",
      singleRentBook: {},
      pdfFile: "",
      isEmpty: false,
    };
  }

  async componentDidMount() {
    this.getBookData(this.props.match.params.bookId);
    if (this.props.isAuth) {
      this.getCartCount();
      this.getSingleRentBook(this.props.userToken);
      this.getSoldBooks(this.props.userToken);
    }
  }

  getBookData = async (bookId) => {
    const response = await Axios.get(`${url}/api/books/${bookId}`);
    if (response.data.length !== 0) {
      this.setState({
        bookData: response.data,
        authorData: response.data.author,
        isEmpty: false,
      });
    } else {
      this.setState({
        bookData: [],
        authorData: [],
        isEmpty: true,
      });
    }
  };

  getBookFile = async (fileUrl, bookId) => {
    try {
      const pdfFile = await Axios.get(
        `${url}/api/file/image/${fileUrl}/${bookId}`,
        {
          headers: {
            "x-auth-token": this.props.userToken,
          },
        }
      );
      if (pdfFile.data) {
        return pdfFile.data;
      }
    } catch (error) {
      console.log(error);
    }
  };

  getSingleRentBook = async (userToken) => {
    try {
      const response = await Axios.get(
        `${url}/api/rent/single/${this.props.match.params.bookId}`,
        {
          headers: {
            "x-auth-token": userToken,
          },
        }
      );
      if (response.data.length !== 0) {
        this.setState({
          singleRentBook: response.data,
        });
      } else {
        this.setState({ singleRentBook: [] });
      }
    } catch (error) {
      console.clear();
      if (error.response.data) {
        this.getSoldBooks(this.props.userToken);
      }
    }
  };

  getCartCount = async () => {
    const response = await Axios.get(`${url}/api/carts/cartDetails`, {
      headers: {
        "x-auth-token": this.props.userToken,
      },
    });
    this.setState({
      cartCount: response.data.cart.length,
    });
  };

  getSoldBooks = async (userToken) => {
    const response = await Axios.get(`${url}/api/sold/mybooks`, {
      headers: {
        "x-auth-token": userToken,
      },
    });
    if (response.data.length !== 0) {
      response.data.map((data) =>
        data.itemDetails.map((item) =>
          this.setState({
            soldBooks: [...this.state.soldBooks, { bookId: item.bookId }],
          })
        )
      );
    }
  };

  handleCurrentPage = (e, newValue) => {
    this.setState({
      currentPage: newValue,
    });
  };

  showNavPage = (page, bookData, authorData) => {
    switch (page) {
      case "Specification":
        return <Specification bookData={bookData} authorData={authorData} />;

      case "Description":
        return <Description bookData={bookData} />;

      default:
        break;
    }
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = (notificationStyle, message) => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        className={notificationStyle}
        autoHideDuration={1600}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="success"
          elevation={6}
          variant="filled"
        >
          {message}
        </MuiAlert>
      </SnackBar>
    );
  };

  handleCart = async (bookId) => {
    if (this.props.isAuth) {
      const response = await Axios.post(
        `${url}/api/carts/addToCart`,
        { bookId: bookId },
        {
          headers: {
            "x-auth-token": this.props.userToken,
          },
        }
      );
      if (response.data.success) {
        this.setState({
          success: response.data.success,
          alreadyExist: "",
        });
        this.getCartCount();
        this.handleNotificationOpen();
      }
      if (response.data.bookInCart) {
        this.setState({
          alreadyExist: response.data.bookInCart,
          success: "",
        });
        this.getCartCount();
        this.handleNotificationOpen();
      }
    } else {
      this.props.history.push("/login/Customer");
    }
  };

  handleBuyBook = (bookId) => {
    sessionStorage.setItem("orderId", this.generateId(16));
    this.props.history.push(`/book/buy/${bookId}`);
  };

  dec2Hex = (dec) => {
    return dec < 10 ? "0" + String(dec) : dec.toString(16);
  };

  generateId = (length) => {
    let arr = new Uint8Array((length || 40) / 2);
    window.crypto.getRandomValues(arr);
    return Array.from(arr, this.dec2Hex).join("");
  };

  handleRead = (bookId) => {
    window.open(`/book/read/${bookId}`, "_blank");
  };

  handleRent = (bookId) => {
    sessionStorage.setItem("orderId", this.generateId(16));
    this.props.history.push(`/book/rent/${bookId}`);
  };

  checkExistSold = (bookId) => {
    let bookSold = this.state.soldBooks.find((book) => book.bookId === bookId);
    if (bookSold) {
      return true;
    } else {
      return false;
    }
  };

  render() {
    const { classes } = this.props;
    const { bookData, authorData, singleRentBook } = this.state;
    let isExpired = moment(singleRentBook.createdAt)
      .add(singleRentBook.rentedDays, "days")
      .isAfter(moment(new Date()));
    return (
      <div>
        <Header cartCount={this.state.cartCount} />
        {this.state.bookData.length !== 0 ? (
          <div className={classes.root}>
            <div style={{ fontSize: 25 }}>Details</div>
            <Divider />
            <br />
            <Grid container spacing={3} className={classes.gridContainer}>
              <Grid item xs={12} sm={12} md={9} xl={9} lg={9}>
                <Paper
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Tabs
                    value={this.state.currentPage}
                    onChange={this.handleCurrentPage}
                    variant="fullWidth"
                    style={{ outline: "none" }}
                    TabIndicatorProps={{ style: { background: "#0a1f3a" } }}
                    textColor="inherit"
                  >
                    {this.state.bottomNavigation.map((option, index) => (
                      <Tab
                        label={option.label}
                        value={option.label}
                        key={index}
                        classes={{
                          root: classes.tabRoot,
                          selected: classes.selectedStyle,
                        }}
                        className={classes.navStyle}
                      />
                    ))}
                  </Tabs>
                </Paper>
                {this.showNavPage(this.state.currentPage, bookData, authorData)}
                <br />

                {singleRentBook._id && isExpired && (
                  <div
                    style={{
                      width: "100%",
                      fontSize: 20,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {console.log("enter", singleRentBook)}
                    <p>
                      You have rented this books for
                      {singleRentBook.rentedDays} days
                    </p>
                    <p>
                      You can rent further after this book has passed expiry
                      date.
                    </p>
                    <p>
                      Expiry Date:-
                      {moment(singleRentBook.createdAt)
                        .add(singleRentBook.rentedDays, "days")
                        .format("LLLL")}
                    </p>
                  </div>
                )}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={3}
                xl={3}
                lg={3}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img
                  src={bookData.bookCoverUrl}
                  alt="bookCover"
                  style={{ width: 300, height: 300 }}
                />
                <br />

                {singleRentBook._id && isExpired ? (
                  <React.Fragment>
                    <Button
                      variant="outlined"
                      className={classes.buttonStyle}
                      onClick={() => this.handleRent(bookData._id)}
                    >
                      <StoreIcon style={{ marginRight: 5 }} />
                      Rent More
                    </Button>
                    <Button
                      variant="outlined"
                      className={classes.buttonStyle}
                      onClick={() => this.handleRead(bookData._id)}
                    >
                      <BookIcon />
                      Read
                    </Button>
                  </React.Fragment>
                ) : this.checkExistSold(bookData._id) ? (
                  <React.Fragment>
                    <div style={{ textAlign: "center", fontSize: 18 }}>
                      Already Bought
                    </div>
                    <br />
                    <a
                      href={this.getBookFile(
                        bookData.bookFileUrl,
                        bookData._id
                      )}
                      download={`${bookData.title}.pdf`}
                      style={{
                        textDecoration: "none",
                      }}
                    >
                      <Button
                        variant="outlined"
                        className={classes.buttonStyle}
                      >
                        <GetAppIcon style={{ marginRight: 5 }} />
                        Download
                      </Button>
                    </a>
                  </React.Fragment>
                ) : (
                  <div className={classes.buttonRoot}>
                    <Button
                      variant="outlined"
                      className={classes.buttonStyle}
                      onClick={() => this.handleRent(bookData._id)}
                    >
                      <StoreIcon style={{ marginRight: 5 }} />
                      Rent
                    </Button>
                    <Button
                      variant="outlined"
                      className={classes.buttonStyle}
                      onClick={() => this.handleCart(bookData._id)}
                    >
                      <ShoppingCartIcon style={{ marginRight: 5 }} />
                      Add to Cart
                    </Button>
                    <Button
                      variant="outlined"
                      className={classes.buttonStyle}
                      onClick={() => this.handleBuyBook(bookData._id)}
                    >
                      <ShopIcon style={{ marginRight: 5 }} />
                      Buy Now
                    </Button>
                  </div>
                )}
              </Grid>
            </Grid>
            <SimilarAuthorBooks authorData={authorData} bookData={bookData} />
            <br />
            <SimilarGenreBooks bookData={bookData} />
            {this.state.success
              ? this.showNotification(
                  classes.notificationStyle,
                  this.state.success
                )
              : this.showNotification(
                  classes.notificationStyle,
                  this.state.alreadyExist
                )}
          </div>
        ) : (
          this.state.isEmpty === false && <CustomLoader />
        )}

        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userToken: state.UserReducer.token,
    isAuth: state.UserReducer.isAuth,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(UserDetailBook));
